import React from 'react';

const BlogItem = ({ title, author, date, description, slug, category }) => {
  return (
    <div class="blog-list text-center mb-14">
      <h2 class="text-3xl tracking-loose leading-10 font-semibold text-gray-900 ">{title}</h2>
      <div class="mt-6 flex justify-center">
        <h2 class="text-base tracking-loose leading-10 text-gray-400 ">{date}</h2>
        <h2 class="flex ml-10 text-base tracking-loose leading-10 text-yellow ">{category}</h2>
      </div>
      <p class="mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl ">{description}</p>
      <div class="mt-6">
        <a class="font-bold underline hover:text-gray-500" href={slug}>
          Read More
        </a>
      </div>
    </div>
  );
};

export default BlogItem;
